import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4.533 3.934c-.626 0-1.133.507-1.133 1.133v8.348c0 .626.507 1.133 1.133 1.133h1.67a1 1 0 0 1 1 1v2.038l2.73-2.73v-2.322A3.133 3.133 0 0 1 13.067 9.4h5.4V5.067c0-.626-.508-1.133-1.134-1.133h-12.8Zm15.934 5.63V5.066a3.133 3.133 0 0 0-3.134-3.133h-12.8A3.133 3.133 0 0 0 1.4 5.067v8.348a3.133 3.133 0 0 0 3.133 3.133h.67V20a1 1 0 0 0 1.707.707l3.29-3.29a3.134 3.134 0 0 0 2.867 1.867h2.96l2.49 2.49a1 1 0 0 0 1.706-.707v-1.875a3.135 3.135 0 0 0 2.377-3.041v-3.617c0-1.381-.893-2.553-2.133-2.97Zm-8.534 6.587c0 .626.508 1.133 1.134 1.133h3.374a1 1 0 0 1 .707.293l1.075 1.076v-.369a1 1 0 0 1 1-1h.244c.626 0 1.133-.507 1.133-1.133v-3.617c0-.626-.507-1.134-1.133-1.134h-6.4c-.626 0-1.134.508-1.134 1.134v3.617Z"
  />,
  'MessageChat1'
)
